import script from "./OrderButton.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderButton.vue?vue&type=script&setup=true&lang=js"

import "./OrderButton.vue?vue&type=style&index=0&id=481dcd68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481dcd68"]])

export default __exports__